
import AMapLoader from '@amap/amap-jsapi-loader';
export const loadAMap = (() => {
    let promise;
    return () => {
        if (window.AMap !== undefined) return Promise.resolve(window.AMap);
        if (promise) return promise;

        window._AMapSecurityConfig = {
            securityJsCode: '33ad6ad4c61e88a49a6d0066478c77b4'
        };

        promise = AMapLoader.load({
            key: '7510953ec3aa93a94ecb83bc54e6d190', // 申请好的Web端开发者Key，首次调用 load 时必填
            version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            AMapUI: {
                // 是否加载 AMapUI，缺省不加载
                version: '1.1', // AMapUI 版本
                plugins: [] // 需要加载的 AMapUI ui插件
            },
            Loca: {
                // 是否加载 Loca， 缺省不加载
                version: '2.0' // Loca 版本
            }
        });

        return promise;
    };
})();

export function isExternalHttpWorked() {
    return fetch('https://vdata.amap.com/style/2.0.1')
        .then(res => res.status === 200)
        .catch(e => false);
}
